"use strict";

var marko_template = module.exports = require("marko/dist/vdom").t(),
    marko_component = {
        onCreate: function() {
          this.state = {
              title: "",
              message: "",
              show: false
            };

          GState.bind(this, [
              "tenant"
            ]);
        },
        onMount: function() {
          if ((this.state.tenant && this.state.tenant.subscription) && this.state.tenant.subscription.type) {
            const expiryDate = moment(this.state.tenant.subscription.duration.end);

            if (moment().isAfter(expiryDate)) {
              this.setState({
                  show: true,
                  title: "Subscription expired",
                  message: ("Your subscription has expired on " + formatDate(expiryDate, "calendar")) + ". Renew it <a href=\"/subscription\">here</a> as soon as possible to prevent your account from imminant suspension."
                });

              return;
            }
          }
        },
        onDismiss: function() {
          this.state.show = false;
        }
      },
    components_registry_browser = require("marko/dist/runtime/components/registry-browser"),
    marko_registerComponent = components_registry_browser.r,
    marko_componentType = marko_registerComponent("/MP.WEB$2.0/src/views/smoothy~1.0/components/GlobalAlert.marko", function() {
      return module.exports;
    }),
    marko_renderer = require("marko/dist/runtime/components/renderer"),
    marko_defineComponent = require("marko/dist/runtime/components/defineComponent"),
    module_moment = require("moment"),
    moment = module_moment.default || module_moment,
    Locale_template = require("../../components/Locale/index.marko"),
    marko_loadTag = require("marko/dist/runtime/helpers/load-tag"),
    Locale_tag = marko_loadTag(Locale_template),
    Bx_template = require("../../components/Bx/index.marko"),
    Bx_tag = marko_loadTag(Bx_template),
    marko_attrs0 = {
        style: "width:calc(100% - 4rem)",
        "class": "position-relative px-5 py-2 bg-primary"
      },
    marko_attrs1 = {
        "class": "py-25"
      },
    marko_attrs2 = {
        "class": "font-large-1 m-0"
      },
    marko_attrs3 = {
        "class": "position-absolute top-0 right-0 p-1 mx-1 my-25 cursor-pointer"
      },
    marko_attrs4 = {
        "class": "font-medium-3 font-weight-300 white-text"
      };

function render(input, out, __component, component, state) {
  var data = input;

  if (state.show) {
    out.be("div", marko_attrs0, "0", component);

    out.be("div", marko_attrs1, "1", component);

    out.be("h4", marko_attrs2, "2", component);

    Locale_tag({
        text: state.title,
        class: "white-text"
      }, out, __component, "3");

    out.ee();

    out.be("span", marko_attrs3, "4", component, null, 0, {
        onclick: __component.d("click", "onDismiss", false)
      });

    Bx_tag({
        type: "x",
        class: "font-large-2 white-text"
      }, out, __component, "5");

    out.ee();

    out.ee();

    out.be("p", marko_attrs4, "6", component);

    Locale_tag({
        text: state.message
      }, out, __component, "7");

    out.ee();

    out.ee();
  }
}

marko_template._ = marko_renderer(render, {
    e_: marko_componentType
  }, marko_component);

marko_template.Component = marko_defineComponent(marko_component, marko_template._);
